(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-lux-native-designer-search]')) return;
    const query = event.target.value.trim().toLowerCase();
    const component = event.target.closest('facet-inputs-component');
    component.querySelectorAll('.facets__inputs-list-item').forEach((item) => {
      const matches = query === '' || item.textContent.toLowerCase().includes(query);
      item.hidden = !matches;
      item.classList.toggle('lux-native-search-match', query !== '' && matches);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lux-filter-fallback"] && !Shopify.designMode) return;
  try {
    if (!window.luxFilterFallbackReady) {
    window.luxFilterFallbackReady = true;

    const syncFallbackFilters = (root) => {
      const params = new URLSearchParams(window.location.search);
      root.querySelectorAll('input[data-filter-param]').forEach((input) => {
        input.checked = params.getAll(input.dataset.filterParam).includes(input.value);
      });
      root.querySelectorAll('input[data-price-min]').forEach((input) => {
        const minimum = params.get('filter.v.price.gte') || '';
        const maximum = params.get('filter.v.price.lte') || '';
        input.checked = minimum === (input.dataset.priceMin || '') && maximum === (input.dataset.priceMax || '');
      });
    };

    const refreshSaveButtons = () => {
      let saved = [];
      try { saved = JSON.parse(localStorage.getItem('luxury-resale-saved-searches') || '[]'); } catch (error) { saved = []; }
      const current = window.location.pathname + window.location.search;
      document.querySelectorAll('[data-lux-save-search]').forEach((button) => {
        const label = button.querySelector('[data-lux-save-label]');
        const isSaved = saved.includes(current);
        button.dataset.saved = isSaved ? 'true' : 'false';
        if (label) label.textContent = isSaved ? label.dataset.savedLabel : label.dataset.unsavedLabel;
      });
    };

    const hydrate = () => {
      document.querySelectorAll('[data-lux-filter-fallback]').forEach(syncFallbackFilters);
      refreshSaveButtons();
    };

    document.addEventListener('input', (event) => {
      if (!event.target.matches('[data-lux-designer-search]')) return;
      const query = event.target.value.trim().toLowerCase();
      event.target.closest('.lux-filter-group').querySelectorAll('[data-lux-filter-option]').forEach((option) => {
        option.hidden = query !== '' && !option.textContent.toLowerCase().includes(query);
      });
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.closest('[data-lux-filter-fallback]')) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (input.matches('[data-filter-param]')) {
        const currentValues = url.searchParams.getAll(input.dataset.filterParam).filter((value) => value !== input.value);
        url.searchParams.delete(input.dataset.filterParam);
        currentValues.forEach((value) => url.searchParams.append(input.dataset.filterParam, value));
        if (input.checked) url.searchParams.append(input.dataset.filterParam, input.value);
      }
      if (input.matches('[data-price-min]')) {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        if (input.checked) {
          if (input.dataset.priceMin) url.searchParams.set('filter.v.price.gte', input.dataset.priceMin);
          if (input.dataset.priceMax) url.searchParams.set('filter.v.price.lte', input.dataset.priceMax);
        }
      }
      window.location.assign(url.toString());
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-lux-save-search]');
      if (!button) return;
      const current = window.location.pathname + window.location.search;
      let saved = [];
      try { saved = JSON.parse(localStorage.getItem('luxury-resale-saved-searches') || '[]'); } catch (error) { saved = []; }
      saved = saved.includes(current) ? saved.filter((url) => url !== current) : [...saved, current];
      localStorage.setItem('luxury-resale-saved-searches', JSON.stringify(saved.slice(-20)));
      refreshSaveButtons();
    });

    document.addEventListener('DOMContentLoaded', hydrate, { once: true });
    document.addEventListener('shopify:section:load', hydrate);
    hydrate();
  }
  } catch(e) { console.error(e); }
})();

})();
